import { Dispatch, useCallback, useMemo, useState } from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { v4 as uuidv4 } from 'uuid';
import { connect, useDispatch } from 'react-redux';
import { FormSpy } from 'react-final-form';

import { ShowMoreButton } from 'UIPackage/MainModule/components/ShowMoreButton/ShowMoreButton';
import { ErknmKnmDocumentTypeCodesEnum } from 'APIPackage/CatalogsModule/enums/ErknmKnmDocumentTypeCodesEnum';
import { IKnmAttachment } from 'APIPackage/KnmModule/interfaces/IKnmAttachment';
import {
  getCatalogErknmKnmDocumentTypesSelectOptions,
  getCatalogKnmDocumentTypesSelectOptions,
} from 'CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { IKnmDocumentTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmDocumentTypeSelectOption';
import { KNM_DOCUMENTS } from 'CorePackage/MainModule/routes/routes';
import { getDocumentBlockId } from 'KnmPackage/MainModule/constants/fieldsElementsIds';
import {
  getKnmIsErknmStatusApproving,
  getKnmIsErknmStatusCommentsExist,
  getKnmIsErknmStatusDecisionAppealed,
  getKnmIsErknmStatusFillInProcess,
  getKnmIsErknmStatusNotApprove,
  getKnmIsErknmStatusReadyForApprove,
  getKnmIsErknmStatusRejectAppealed,
  getKnmIsErknmStatusTypeCantBeCarryOut,
  getKnmIsErknmStatusTypeCarriedOut,
  getKnmIsErknmStatusTypeCompleted,
  getKnmIsErknmStatusTypeWaitingCarryOut,
  getKnmIsErpStatusDeleted,
  getKnmSystemType,
} from 'KnmPackage/MainModule/selectors/knmSelectors';
import { Button } from 'UIPackage/MainModule/components/Button';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { KnmDocumentsModal } from 'KnmPackage/KnmDocumentsModule/components/KnmDocumentsModal';
import { KnmSignDocumentModal } from 'KnmPackage/KnmDocumentsModule/components/KnmSignDocumentModal';
import { IKnmDocument } from 'APIPackage/KnmModule/interfaces/IKnmDocument';
import { KnmSystemTypesEnum } from 'KnmPackage/MainModule/enums/KnmSystemTypesEnum';
import { KnmAttachmentsList } from 'KnmPackage/MainModule/components/KnmAttachmentsList';
import { IKnmTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmTypeSelectOption';
import { IDictionaryKnmKindSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryKnmKindSelectOption';
import { DocumentsTypeCodesEnum } from 'KnmErknmPackage/MainModule/enums/DocumentsTypeCodesEnum';
import { Section } from 'UIPackage/FormModule/components/Section';
import { Row } from 'UIPackage/FormModule/components/Row';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IKnmFormRenderProps } from 'KnmPackage/MainModule/components/KnmForm';
import { ChangeKnmModalFormRenderProps } from 'KnmPackage/MainModule/types/ChangeKnmModalFormRenderProps';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { KnmCollapse } from 'KnmPackage/MainModule/components/KnmCollapse';
import {
  getUserRoleIsProsecutorOrSuperProsecutor,
  getUserRoleIsSupervisor,
} from 'AuthPackage/MainModule/selectors/authSelectors';

import { IKnmAttachmentDocument } from '../interfaces/IKnmAttachmentDocument';
import { IKnmFormDocument } from '../interfaces/IKnmFormDocument';
import styles from './KnmDocuments.module.scss';
import { knmDocumentsSaveSignedDocument } from '../actions/knmDocumentsActions';
import { clippedKnmDocumentTypes } from '../common/clippedKnmDocumentTypes';
import { ReactQuillEditorField } from '../../../UIPackage/MainModule/components/ReactQuillEditorField';
import { TextareaField } from '../../../UIPackage/MainModule/components/TextareaField';
import { useShowMore } from '../../../hooks/useShowMore';
import { Spinner } from '../../../UIPackage/MainModule/components/Spinner';

interface IKnmDocumentsProps {
  decisionDisabled?: boolean;
  disableDeleteDocuments?: boolean;
  formInstance?: IKnmFormRenderProps['form'] | ChangeKnmModalFormRenderProps['form'];
  kindKnm?: IDictionaryKnmKindSelectOption;
  knmDocuments?: IKnmDocument[] | null;
  reasonDocument?: boolean;
  title: string;
  typeErknm?: IKnmTypeSelectOption;
  watchOnly?: boolean;
  isPm?: boolean;
  reasonChangeCode?: string;
}

interface IKnmDocumentsStoreProps {
  isKnmStatusApproving: boolean;
  isKnmStatusCommentsExist: boolean;
  isKnmStatusDecisionAppealed: boolean;
  isKnmStatusFillInProcess: boolean;
  isKnmStatusNotApprove: boolean;
  isKnmStatusReadyForApprove: boolean;
  isKnmStatusRejectAppealed: boolean;
  isKnmStatusTypeCantBeCarryOut: boolean;
  isKnmStatusTypeCarriedOut: boolean;
  isKnmStatusTypeCompleted: boolean;
  isKnmStatusTypeDeleted: boolean;
  isKnmStatusTypeWaitingCarryOut: boolean;
  isProsecutorOrSuperProsecutor: boolean;
  isSupervisor: boolean;
  knmDocumentTypesSelectOptions: IKnmDocumentTypeSelectOption[];
  knmSystemType: KnmSystemTypesEnum | undefined;
}

function KnmDocumentsWithoutStore({
  decisionDisabled,
  disableDeleteDocuments,
  formInstance,
  kindKnm,
  knmDocuments,
  reasonDocument,
  title,
  typeErknm,
  watchOnly,
  isKnmStatusApproving,
  isKnmStatusCommentsExist,
  isKnmStatusDecisionAppealed,
  isKnmStatusFillInProcess,
  isKnmStatusNotApprove,
  isKnmStatusReadyForApprove,
  isKnmStatusRejectAppealed,
  isKnmStatusTypeCantBeCarryOut,
  isKnmStatusTypeCarriedOut,
  isKnmStatusTypeCompleted,
  isKnmStatusTypeDeleted,
  isKnmStatusTypeWaitingCarryOut,
  isProsecutorOrSuperProsecutor,
  isSupervisor,
  knmDocumentTypesSelectOptions,
  knmSystemType,
  isPm,
  reasonChangeCode,
}: IKnmDocumentsProps & IKnmDocumentsStoreProps) {
  const form = formInstance as IKnmFormRenderProps['form'] | undefined;
  const isErknmSystemType = knmSystemType === KnmSystemTypesEnum.ERKNM;
  const isKnm = knmSystemType === KnmSystemTypesEnum.ERKNM;
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const push = form?.mutators.push;
  const remove = form?.mutators.remove;

  const filteredKnmDocumentTypesSelectOptions: IKnmDocumentTypeSelectOption[] = useMemo(() => {
    if (reasonDocument) {
      if (reasonChangeCode === 'RSN_CHNG_PP_XXII') {
        return knmDocumentTypesSelectOptions.filter(item => item.code === ErknmKnmDocumentTypeCodesEnum.PP_XV);
      }

      return knmDocumentTypesSelectOptions.filter(
        item =>
          item.code === ErknmKnmDocumentTypeCodesEnum.PP_0 ||
          item.code === ErknmKnmDocumentTypeCodesEnum.PP_I ||
          item.code === ErknmKnmDocumentTypeCodesEnum.PP_II ||
          item.code === ErknmKnmDocumentTypeCodesEnum.PP_III ||
          item.code === ErknmKnmDocumentTypeCodesEnum.PP_IV,
      );
    }
    if (isErknmSystemType) {
      return knmDocumentTypesSelectOptions.filter(item => {
        if (clippedKnmDocumentTypes.includes(item.code)) {
          return false;
        }
        if (
          isSupervisor ||
          (isProsecutorOrSuperProsecutor &&
            (item.code === ErknmKnmDocumentTypeCodesEnum.AP_VI ||
              item.code === ErknmKnmDocumentTypeCodesEnum.AP_VII ||
              item.code === ErknmKnmDocumentTypeCodesEnum.VP_VI))
        ) {
          if (isKnmStatusFillInProcess || isKnmStatusReadyForApprove) {
            if (decisionDisabled === true) {
              switch (item.code) {
                case ErknmKnmDocumentTypeCodesEnum.VP_I:
                case ErknmKnmDocumentTypeCodesEnum.VP_II:
                case ErknmKnmDocumentTypeCodesEnum.VP_IV:
                case ErknmKnmDocumentTypeCodesEnum.VP_VI:
                  return true;
                default:
                  return false;
              }
            } else {
              switch (item.code) {
                case ErknmKnmDocumentTypeCodesEnum.VP_0:
                case ErknmKnmDocumentTypeCodesEnum.VP_I:
                case ErknmKnmDocumentTypeCodesEnum.VP_II:
                case ErknmKnmDocumentTypeCodesEnum.VP_IV:
                case ErknmKnmDocumentTypeCodesEnum.VP_VI:
                  return true;
                default:
                  return false;
              }
            }
          }
          if (
            isKnmStatusApproving ||
            isKnmStatusNotApprove ||
            isKnmStatusCommentsExist ||
            isKnmStatusRejectAppealed ||
            isKnmStatusTypeWaitingCarryOut ||
            isKnmStatusTypeCantBeCarryOut ||
            isKnmStatusTypeDeleted
          ) {
            switch (item.code) {
              case ErknmKnmDocumentTypeCodesEnum.VP_VI:
                return true;
              default:
                return false;
            }
          }
          if (isKnmStatusTypeCarriedOut) {
            switch (item.code) {
              case ErknmKnmDocumentTypeCodesEnum.VP_III:
              case ErknmKnmDocumentTypeCodesEnum.AP_0:
              case ErknmKnmDocumentTypeCodesEnum.MZ_0:
              case ErknmKnmDocumentTypeCodesEnum.VP_VI:
                return true;
              default:
                return false;
            }
          }
          if (isKnmStatusTypeCompleted || isKnmStatusDecisionAppealed) {
            switch (item.code) {
              case ErknmKnmDocumentTypeCodesEnum.VP_III:
              case ErknmKnmDocumentTypeCodesEnum.AP_0:
              case ErknmKnmDocumentTypeCodesEnum.MZ_0:
              case ErknmKnmDocumentTypeCodesEnum.AP_VI:
              case ErknmKnmDocumentTypeCodesEnum.AP_VII:
              case ErknmKnmDocumentTypeCodesEnum.VP_VI:
                return true;
              default:
                return false;
            }
          }
        }

        return false;
      });
    }

    return knmDocumentTypesSelectOptions;
  }, [isErknmSystemType, knmDocumentTypesSelectOptions, kindKnm, typeErknm, reasonDocument, reasonChangeCode]);

  const [isVisibleAccompanyingDocsModal, setVisibleAccompanyingDocsModal] = useState<boolean>(false);
  const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);
  const [formFieldName, setFormFieldName] = useState<string | null>(null);

  const addDocument = useCallback(() => !watchOnly && push && push('documents', { isNew: true, listId: uuidv4() }), [
    push,
    watchOnly,
  ]);

  const makeRemoveDocumentHandler = (index: number) => () => !watchOnly && remove && remove('documents', index);

  const addAttachment = useCallback(
    (fieldName: string, data: IKnmAttachmentDocument) => !watchOnly && push && push(fieldName, data),
    [push, watchOnly],
  );

  const handleCloseAccompanyingDocsModal = useCallback(() => {
    setVisibleAccompanyingDocsModal(false);
  }, []);

  const handleOpenAccompanyingDocsModal = useCallback(() => {
    setVisibleAccompanyingDocsModal(true);
  }, []);

  const handleCloseSignModal = useCallback(() => {
    setIsVisibleSignModal(false);
    setFormFieldName(null);
  }, []);

  const handleOpenSignModal = (fieldName: string) => () => {
    setIsVisibleSignModal(true);
    setFormFieldName(fieldName);
  };

  const handleSaveSignedDocument = useCallback(
    (signedDocument: File, signatureInfo: IKnmAttachment['signatureInfo']) => {
      dispatch(knmDocumentsSaveSignedDocument(form, signedDocument, signatureInfo, formFieldName, addAttachment));
      handleCloseSignModal();
    },
    [addAttachment, dispatch, form, formFieldName, handleCloseSignModal],
  );

  return (
    <Section
      title={title}
      id={KNM_DOCUMENTS}
      type="list"
      customButton={
        !isPm && (
          <>
            <Button
              className="shared-btn-add"
              text="Добавить"
              type="button"
              variant="link"
              color="primary"
              disabled={watchOnly}
              onClick={addDocument}
            />
            {!isErknmSystemType && (
              <Button
                className={styles.ShowDocumentsButton}
                text="Просмотр сопроводительной документации"
                type="button"
                variant="link"
                color="primary"
                onClick={handleOpenAccompanyingDocsModal}
              />
            )}
          </>
        )
      }
    >
      <FieldArray name="documents">
        {({ fields }) => {
          const { visibleItems, hasMore, showMore, totalCount, visibleCount, isRendering } = useShowMore(fields.value, {
            initialCount: 10,
            incrementCount: 10,
          });

          if (!fields.length) {
            return null;
          }

          return (
            <>
              <Row>
                {visibleItems.map((fieldValue: IKnmFormDocument, originalIndex: number) => {
                  const index =
                    fields.value?.findIndex((item: IKnmFormDocument) => item === fieldValue) ?? originalIndex;
                  const name = `documents[${index}]`;
                  const id = getDocumentBlockId(fieldValue.listId);

                  if (fieldValue.type?.code === DocumentsTypeCodesEnum.WEB_0) {
                    return null;
                  }

                  if (decisionDisabled === true && fieldValue.type?.code === ErknmKnmDocumentTypeCodesEnum.VP_0) {
                    return null;
                  }

                  return (
                    <KnmCollapse
                      theme="fields"
                      title={`Документ №${index + 1}`}
                      id={id}
                      key={id}
                      isNew={fieldValue.isNew}
                      opened={fieldValue.isNew}
                      onClose={fieldValue.isNew ? makeRemoveDocumentHandler(index) : undefined}
                    >
                      <Row>
                        <FieldBlock label="Тип документа" color="black">
                          <SelectInputField
                            className="shared-field_margin-bottom"
                            name={`${name}.type`}
                            options={filteredKnmDocumentTypesSelectOptions}
                            isClearable={false}
                            disabled={watchOnly || !fieldValue.isNew}
                          />
                        </FieldBlock>
                        <FieldBlock label="Описание" color="black">
                          {isKnm ? (
                            <ReactQuillEditorField
                              name={`${name}.descriptionReactQuillEditor`}
                              disabled={watchOnly || !fieldValue.isNew}
                              handleCustomChange={(e: string) => {
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                form?.change(`${name}.description` as any, e);
                              }}
                            />
                          ) : (
                            <TextareaField
                              className="shared-field"
                              inputClassName={styles.DescriptionInput}
                              name={`${name}.description`}
                              disabled={watchOnly || !fieldValue.isNew}
                            />
                          )}
                        </FieldBlock>
                        <FormSpy subscription={{ errors: true, touched: true, values: true }}>
                          {props => {
                            const fieldName = `${name}.attachments`;

                            const isReasonChangeTypeTouched =
                              props.touched?.[`changePlanReason[${index}].reasonChangeType`];
                            let isRequiredAndInvalid = false;

                            if (isReasonChangeTypeTouched) {
                              const documents = props.values?.documents || [];

                              const hasPPXVDocument = documents.some(
                                (doc: IKnmFormDocument) => doc?.type?.code === 'PP_XV',
                              );

                              const currentAttachments = documents[index]?.attachments || [];

                              isRequiredAndInvalid = hasPPXVDocument && currentAttachments.length === 0;
                            }

                            return (
                              <div className={styles.FieldWithAsterisk}>
                                <FieldBlock
                                  label={
                                    <>
                                      Файлы
                                      {isRequiredAndInvalid && <span className={styles.MarkRequiredFile}>*</span>}
                                    </>
                                  }
                                  color="black"
                                  button={
                                    <Button
                                      className={styles.AddFileButton}
                                      text="Добавить"
                                      type="button"
                                      variant="link"
                                      color="primary"
                                      id="fileAddButton"
                                      onClick={handleOpenSignModal(fieldName)}
                                      disabled={watchOnly || !fieldValue.isNew}
                                    />
                                  }
                                />
                              </div>
                            );
                          }}
                        </FormSpy>
                        <FormSpy subscription={{ errors: true, touched: true, values: true }}>
                          {props => {
                            if (props.errors?.documents) {
                              const fieldError = props.errors?.documents[index]?.attachments;
                              const errorMessage: string | undefined = fieldError
                                ? (Object.values(fieldError).reduce(
                                    (prev: string, curr: string) => prev + curr,
                                    '',
                                  ) as string)
                                : undefined;

                              if (errorMessage) {
                                return <p className="shared-input-error">Поле не может быть пустым</p>;
                              }
                            }

                            return null;
                          }}
                        </FormSpy>
                        <Row>
                          <KnmAttachmentsList
                            name={`${name}.attachments`}
                            removeField={remove}
                            isWatchOnly={!fieldValue.isNew || watchOnly || disableDeleteDocuments}
                            isShowDateTime={true}
                          />
                        </Row>
                      </Row>
                    </KnmCollapse>
                  );
                })}
              </Row>
              {isRendering && <Spinner className={styles.Loader} />}
              {hasMore && !isRendering && (
                <ShowMoreButton onClick={showMore} totalCount={totalCount} visibleCount={visibleCount} />
              )}
            </>
          );
        }}
      </FieldArray>
      <KnmDocumentsModal
        knmDocuments={knmDocuments}
        isVisibleModal={isVisibleAccompanyingDocsModal}
        onCloseModal={handleCloseAccompanyingDocsModal}
      />
      <KnmSignDocumentModal
        isVisibleModal={isVisibleSignModal}
        fieldName="documents"
        onCloseSignModal={handleCloseSignModal}
        onSaveSignedDocument={handleSaveSignedDocument}
      />
    </Section>
  );
}

const mapStateToProps = (state: IRootState): IKnmDocumentsStoreProps => {
  const knmSystemType = getKnmSystemType(state);
  const isErknmSystemType = knmSystemType === KnmSystemTypesEnum.ERKNM;
  const isProsecutorOrSuperProsecutor = getUserRoleIsProsecutorOrSuperProsecutor(state);
  const isSupervisor = getUserRoleIsSupervisor(state);
  const isKnmStatusFillInProcess = getKnmIsErknmStatusFillInProcess(state);
  const isKnmStatusReadyForApprove = getKnmIsErknmStatusReadyForApprove(state);
  const isKnmStatusApproving = getKnmIsErknmStatusApproving(state);
  const isKnmStatusNotApprove = getKnmIsErknmStatusNotApprove(state);
  const isKnmStatusCommentsExist = getKnmIsErknmStatusCommentsExist(state);
  const isKnmStatusRejectAppealed = getKnmIsErknmStatusRejectAppealed(state);
  const isKnmStatusTypeWaitingCarryOut = getKnmIsErknmStatusTypeWaitingCarryOut(state);
  const isKnmStatusTypeCarriedOut = getKnmIsErknmStatusTypeCarriedOut(state);
  const isKnmStatusTypeCompleted = getKnmIsErknmStatusTypeCompleted(state);
  const isKnmStatusDecisionAppealed = getKnmIsErknmStatusDecisionAppealed(state);
  const isKnmStatusTypeCantBeCarryOut = getKnmIsErknmStatusTypeCantBeCarryOut(state);
  const isKnmStatusTypeDeleted = getKnmIsErpStatusDeleted(state);

  return {
    knmSystemType,
    isProsecutorOrSuperProsecutor,
    isSupervisor,
    isKnmStatusFillInProcess,
    isKnmStatusReadyForApprove,
    isKnmStatusApproving,
    isKnmStatusNotApprove,
    isKnmStatusCommentsExist,
    isKnmStatusRejectAppealed,
    isKnmStatusTypeWaitingCarryOut,
    isKnmStatusTypeCarriedOut,
    isKnmStatusTypeCompleted,
    isKnmStatusDecisionAppealed,
    isKnmStatusTypeCantBeCarryOut,
    isKnmStatusTypeDeleted,
    knmDocumentTypesSelectOptions: isErknmSystemType
      ? getCatalogErknmKnmDocumentTypesSelectOptions(state)
      : getCatalogKnmDocumentTypesSelectOptions(state),
  };
};

export const KnmDocuments = connect(mapStateToProps)(KnmDocumentsWithoutStore);
